import React from 'react';
import { TextButton } from '@fiverr-private/button';
import { Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../../../../shared/utils/i18n';

interface ShowMoreToggleProps {
    isExpanded: boolean;
    hiddenCount: number;
    onToggle: () => void;
}

export const ShowMoreToggle = ({ isExpanded, hiddenCount, onToggle }: ShowMoreToggleProps) => (
    <TextButton variant="underline" size="sm" onClick={onToggle}>
        {/* TextButton hardcodes a semibold weight; the design calls for regular. */}
        <Typography as="span" fontWeight="normal" size="b_sm">
            {isExpanded
                ? appTranslate('search_perseus.side_filters.modal_filters.show_less')
                : appTranslate('search_perseus.side_filters.modal_filters.show_more', {
                      params: { count: hiddenCount },
                  })}
        </Typography>
    </TextButton>
);
